document.addEventListener('DOMContentLoaded', () => {
  // Initialize PinchZoom (if available and element exists)
  const pinchZoomEl = document.getElementById('pinch-zoom-container');
  if (typeof PinchZoom === "function" && pinchZoomEl) {
    new PinchZoom(pinchZoomEl, {});
  }

  // Sticky gallery and product info scroll alignment
  const svgGallery = document.querySelector('.tee-gallery-wrapper');
  const productDescription = document.querySelector('.product__scroll-area');
  const productInfoWrapper = document.querySelector('.product__info-wrapper');
  let ticking = false;
  let isUnfrozen = false;

  function checkAlignment() {
    if (!svgGallery || !productDescription || !productInfoWrapper) return;
    const svgRect = svgGallery.getBoundingClientRect();
    const descRect = productDescription.getBoundingClientRect();
    if (svgRect.bottom >= descRect.top && !isUnfrozen) {
      svgGallery.classList.add('static');
      productInfoWrapper.classList.add('no-margin');
      svgGallery.style.position = 'static';
      svgGallery.style.top = 'auto';
      isUnfrozen = true;
    } else if (isUnfrozen && svgRect.bottom < descRect.top) {
      svgGallery.classList.remove('static');
      productInfoWrapper.classList.remove('no-margin');
      svgGallery.style.position = 'sticky';
      svgGallery.style.top = '0px';
      isUnfrozen = false;
    }
  }

  function onScrollOrResize() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        checkAlignment();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });

  if (svgGallery) {
    svgGallery.style.position = 'sticky';
    svgGallery.style.top = '0px';
  }
  checkAlignment();

  // Slider functionality
  const mediaItems = document.querySelectorAll('.product__media-item');
  const dots = document.querySelectorAll('.tee-slider__dots li button');
  let currentIndex = 0;
  const mediaList = document.querySelector('.product__media-list');

  function updateSlider() {
    if (!mediaList) return;
    const offset = -currentIndex * 100;
    mediaList.style.transform = `translateX(\${offset}%)`;
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentIndex = index;
      updateSlider();
    });
  });

  if (mediaItems.length) {
    setInterval(() => {
      currentIndex = (currentIndex + 1) % mediaItems.length;
      updateSlider();
    }, 5000);
  }

  // Touch handling (swipe to slide)
  let touchStartX = 0;
  let touchStartY = 0;
  if (mediaList) {
    mediaList.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    });

    mediaList.addEventListener('touchmove', (e) => {
      const touchEndX = e.touches[0].clientX;
      const touchEndY = e.touches[0].clientY;
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;
      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        e.preventDefault();
      } else if (deltaX > 50) {
        currentIndex = Math.max(0, currentIndex - 1);
        updateSlider();
        e.preventDefault();
      } else if (deltaX < -50) {
        currentIndex = Math.min(mediaItems.length - 1, currentIndex + 1);
        updateSlider();
        e.preventDefault();
      }
    }, { passive: false });
  }
});

// Product Recommendations loader (using IntersectionObserver)
(function() {
  if (!window.__sections__ || !__sections__["product-recommendations"]) return;
  try {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }

              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
            })
            .catch(e => {
              console.error(e);
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  } catch(e) {
    console.error(e);
  }
})();
